module.exports = __webpack_public_path__ + "img/1006691949.cd5cb6e2.png";